import _ from 'lodash';
import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import '../../node_modules/mapbox-gl-compare/style.css';
import { connect } from 'react-redux';

import {
  updateQuadrantI,
  updateMetadata
} from './Map.action';

import styles from '../MapStyles';
let URL;
if (process.env.NODE_ENV === 'production') {
  URL = 'https://tiles.nexview.io';
} else {
  URL = 'http://localhost:8000/api/v1';
}

class Map extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.quadrantI.product !== this.props.quadrantI.product) {
      const mapObjI = {
        id: `${_.toLower(this.props.quadrantI.product)}_${_.toUpper(this.props.site)}_I`,
        type: 'fill',
        source: {
          type: 'vector',
          tiles: [`${URL}/radar/${this.props.quadrantI.hash}/{z}/{x}/{y}.pbf`]
        },
        'source-layer': `${_.toLower(this.props.quadrantI.product)}_${_.toUpper(this.props.site)}`,
        paint: this.props.quadrantI.selectedColor
      };
      this.newMapI.addLayer(mapObjI, 'interstates');
      this.newMapI.removeLayer(`${_.toLower(prevProps.quadrantI.product)}_${_.toUpper(prevProps.site)}_I`);
      this.newMapI.removeSource(`${_.toLower(prevProps.quadrantI.product)}_${_.toUpper(prevProps.site)}_I`);
    }
  }

  componentDidMount() {
    this.newMapI = new mapboxgl.Map({
      container: this.mapI,
      style: styles,
      center: [ this.props.lng, this.props.lat ],
      zoom: this.props.zoom,
      hash: true,
      minZoom: 4.75,
      maxZoom: 11,
      maxBounds: [
        [-171.621336, 12.609098],
        [-51.525066, 69.847479]
      ]
    });
    const mapObjI = {
      id: `${_.toLower(this.props.quadrantI.product)}_${_.toUpper(this.props.site)}_I`,
      type: 'fill',
      source: {
        type: 'vector',
        tiles: [`${URL}/radar/${this.props.quadrantI.hash}/{z}/{x}/{y}.pbf`]
      },
      'source-layer': `${_.toLower(this.props.quadrantI.product)}_${_.toUpper(this.props.site)}`,
      paint: this.props.quadrantI.selectedColor
    };

    const tvs = {
      id: 'tvs',
      type: 'symbol',
      source: {
        type: 'geojson',
        data: `${URL}/symbols/ntv_KTLX.json`
      },
      layout: {
        'icon-image': 'triangle-15',
        'text-size': 10,
        'icon-rotate': {
          property: 'rotation',
          type: 'categorical',
          stops: [
            [30, 30],
            [60, 60],
            [90, 90],
            [120, 120],
            [150, 150],
            [180, 180],
            [210, 210],
            [240, 240],
            [270, 270],
            [300, 300],
            [330, 330],
            [360, 360]
          ],
          default: 180
        },
      }
    };
    this.newMapI.on('load', () => {
      this.newMapI.addLayer(mapObjI, 'interstates');
      this.newMapI.addLayer(tvs);
      this.newMapI.on('mousemove', (evt) => {
        let features = this.newMapI.queryRenderedFeatures(evt.point).filter((arr) => {
          return arr.layer.id == `${_.toLower(this.props.quadrantI.product)}_${_.toUpper(this.props.site)}_I`;
        });
        if (!_.isEmpty(features)) {
          let feature = features[0];
          this.props.updateMetadata({
            lat: evt.lngLat.lat,
            lon: evt.lngLat.lng,
            properties: feature.properties
          });
        }
        else {
          this.props.updateMetadata({
            lat: evt.lngLat.lat,
            lon: evt.lngLat.lng,
            properties: {}
          });
        }
      });
    });
  }

  render() {
    return (
      <div>
        <div
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }}
          ref={ el => this.mapI = el }
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    quadrantI: {
      product: state.mapReducer.quadrantI.product,
      units: state.mapReducer.quadrantI.units,
      selectedColor: state.mapReducer.quadrantI.selectedColor,
      hash: state.mapReducer.quadrantI.hash
    },
    site: state.mapReducer.site,
    enableSlider: state.mapReducer.enableSlider
  };
};

export default connect(mapStateToProps, {
  updateQuadrantI,
  updateMetadata
})(Map);